import { DonationComponent } from './check-out/donation/donation.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyCartsComponent } from './my-carts.component';
import { CartSummaryComponent } from './cart-list/cart-summary/cart-summary.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { CartSearchComponent } from './cart-list/cart-search/cart-search.component';
import { UploadToCartComponent } from './cart-list/cart-summary/upload-to-cart/upload-to-cart.component';
import { SendCartToSalesComponent } from './cart-list/cart-summary/send-cart-to-sales/send-cart-to-sales.component';
import { ShippingAddressComponent } from './check-out/shipping-address/shipping-address.component';
import { FreightShipMethodComponent } from './check-out/freight-ship-method/freight-ship-method.component';
import { PaymentComponent } from './check-out/payment/payment.component';
import { SummaryOrderComponent } from './check-out/summary-order/summary-order.component';
import { EndUserComponent } from './check-out/end-user/end-user.component';
import { TenantComponent } from './check-out/tenant/tenant.component';
import { OrderConfirmationComponent } from './check-out/order-confirmation/order-confirmation.component';
import { SelectLocationComponent } from './check-out/shipping-address/select-location/select-location.component';
import { SelectEndUserComponent } from './check-out/end-user/select-end-user/select-end-user.component';
import { FinanceComponent } from '../finance/finance.component';
import { FinanceDetailsComponent } from '../finance/finance-details/finance-details.component';
import { FinancialSummaryComponent } from '../finance/financial-summary/financial-summary.component';
import { PaymentSetupComponent } from '../my-account/payment-setup/payment-setup.component';
import { WatchListComponent } from './watch-list/watch-list.component';
import { NotificationWatchlistComponent } from './watch-list/notification-watchlist/notification-watchlist.component';

const routes: Routes = [
    {
        path: 'myCarts',
        component: MyCartsComponent,
        data: {
            breadcrumb: 'My Carts',
        },
        children: [
            {
                path: 'cart/:id/:cartName',
                component: CartSummaryComponent,
                data: {
                    breadcrumb: 'cartName',
                },
                children: [
                    {
                        path: 'finance',
                        component: FinanceComponent,
                        data: {
                            breadcrumb: 'Finance',
                        },
                        children: [
                            {
                                path: 'financeDetails/:type',
                                component: FinanceDetailsComponent,
                                data: {
                                    breadcrumb: 'Finance Details',
                                },
                                children: [
                                    {
                                        path: 'financesummary',
                                        component: FinancialSummaryComponent,
                                        data: {
                                            breadcrumb: 'Summary',
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'product/:sku',
                        component: ProductDetailComponent,
                        data: {
                            breadcrumb: 'sku',
                        },
                        children: [
                            {
                                path: 'bundledproduct/:sku',
                                component: ProductDetailComponent,
                                data: {
                                    breadcrumb: 'sku',
                                }
                            }]
                    },
                    {
                        path: 'upload',
                        component: UploadToCartComponent
                    },
                    {
                        path: 'sendtosales',
                        component: SendCartToSalesComponent
                    },
                    {
                        path: 'ship-address',
                        component: ShippingAddressComponent,
                        data: {
                            breadcrumb: 'Ship Address',
                        },
                        children: [
                            {
                                path: 'select-location',
                                component: SelectLocationComponent,
                                data: {
                                    breadcrumb: 'Select Location',
                                },
                            },
                        ]
                    },
                    // {
                    //     path: 'select-location',
                    //     component: SelectLocationComponent,
                    //     data: {
                    //         breadcrumb: 'Select Location',
                    //     },
                    // },
                    {
                        path: 'freight-ship',
                        component: FreightShipMethodComponent,
                        data: {
                            breadcrumb: 'Freight & Shipping Method',
                        },
                    },
                    {
                        path: 'donation',
                        component: DonationComponent,
                        data: {
                            breadcrumb: 'Donation',
                        },
                    },
                    {
                        path: 'payment-method',
                        component: PaymentComponent,
                        data: {
                            breadcrumb: 'Payment',
                        },
                    },
                    {
                        path: 'digitalwallet',
                        component: PaymentSetupComponent,
                        data: {
                            breadcrumb: 'Digital Wallet',
                        },
                    },
                    {
                        path: 'summary-order',
                        component: SummaryOrderComponent,
                        data: {
                            breadcrumb: 'Summary & Order',
                        },
                    },
                    {
                        path: 'end-user',
                        component: EndUserComponent,
                        data: {
                            breadcrumb: 'End User Information',
                        },
                        children: [
                            {
                                path: 'selectenduser',
                                component: SelectEndUserComponent,
                                data: {
                                    breadcrumb: 'Select End User',
                                }
                            },
                        ]
                    },
                    {
                        path: 'tenant',
                        component: TenantComponent,
                        data: {
                            breadcrumb: 'Tenant Information',
                        }
                    },
                    {
                        path: 'order-confirmation',
                        component: OrderConfirmationComponent
                    }
                ]
            },
            {
                path: 'cartSearch/:searchKeyWord',
                component: CartSearchComponent
            },
            {
                path: 'watchlist',
                component: WatchListComponent,
                data: {
                    breadcrumb: 'Watch List',
                },
                children: [
                    {
                        path: 'product/:sku',
                        component: ProductDetailComponent,
                        data: {
                            breadcrumb: 'sku',
                        },
                        children: [
                            {
                                path: 'bundledproduct/:sku',
                                component: ProductDetailComponent,
                                data: {
                                    breadcrumb: 'sku',
                                }
                            }]
                    },
                    {
                        path: 'notification/:sku',
                        component: NotificationWatchlistComponent,
                        data: {
                            breadcrumb: 'Notification',
                        }
                    }
                ]
            }
        ]
    },
    {
        path: 'carts',
        redirectTo: '/myCarts',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MyCartsRoutingModule { }
